const LOGIN_PATH = '/login';
const LOGIN_SSO_PATH = '/loginsso';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const APIROLEMAPPING_PATH = '/api-role-mapping';
const APIROLEMAPPING_CREATE_PATH = `${APIROLEMAPPING_PATH}/them`;
const APIROLEMAPPING_EDIT_PATH = `${APIROLEMAPPING_PATH}/sua`;

const OPENIDDICTAPPLICATION_PATH = '/ung-dung-dang-ky';
const OPENIDDICTAPPLICATION_CREATE_PATH = `${OPENIDDICTAPPLICATION_PATH}/them`;
const OPENIDDICTAPPLICATION_EDIT_PATH = `${OPENIDDICTAPPLICATION_PATH}/sua`;

const MENUITEM_PATH = '/menu';
const MENUITEM_CREATE_PATH = `${MENUITEM_PATH}/them`;
const MENUITEM_EDIT_PATH = `${MENUITEM_PATH}/sua`;

const ROLE_ACCOUNT_PATH = '/role-account';
const ROLE_ACCOUNT_CREATE_PATH = '/role-account/create';
const ROLE_ACCOUNT_EDIT_PATH = '/role-account/edit';

const BOPHAN_PATH = '/bo-phan';
const BOPHAN_CREATE_PATH = `${BOPHAN_PATH}/them`;
const BOPHAN_EDIT_PATH = `${BOPHAN_PATH}/sua`;

const TEAM_PATH = '/team';
const TEAM_CREATE_PATH = `${TEAM_PATH}/them`;
const TEAM_EDIT_PATH = `${TEAM_PATH}/sua`;

const NHANVIEN_PATH = '/nhan-vien';
const NHANVIEN_CREATE_PATH = `${NHANVIEN_PATH}/them`;
const NHANVIEN_EDIT_PATH = `${NHANVIEN_PATH}/sua`;

const HOTRO_PATH = '/ho-tro';
const HOTRO_CREATE_PATH = `${HOTRO_PATH}/them`;
const HOTRO_EDIT_PATH = `${HOTRO_PATH}/sua`;

const YEUCAU_PATH = '/yeu-cau';
const YEUCAU_CREATE_PATH = `${YEUCAU_PATH}/them`;
const YEUCAU_EDIT_PATH = `${YEUCAU_PATH}/sua`;


const KHOA_PATH = '/danh-muc-khoa';
const KHOA_CREATE_PATH = `${KHOA_PATH}/them`;
const KHOA_EDIT_PATH = `${KHOA_PATH}/sua`;

const QUYTRINH_PATH = '/quy-trinh';
const QUYTRINH_CREATE_PATH = `${QUYTRINH_PATH}/them`;
const QUYTRINH_EDIT_PATH = `${QUYTRINH_PATH}/sua`;

const PROJECT_PATH = '/du-an-phat-trien';
const PROJECT_CREATE_PATH = `${PROJECT_PATH}/them`;
const PROJECT_EDIT_PATH = `${PROJECT_PATH}/sua`;
const PROJECT_DETAIL_PATH = `${PROJECT_PATH}/chi-tiet`;

const PROJECT_STEP_BOARD_PATH = `${PROJECT_PATH}/bang-cong-viec-buoc`;

const LINHVUC_PATH = '/danh-muc-linh-vuc';
const LINHVUC_CREATE_PATH = `${LINHVUC_PATH}/them`;
const LINHVUC_EDIT_PATH = `${LINHVUC_PATH}/sua`;

const LOAIYEUCAU_PATH = '/danh-muc-loai-yeu-cau';
const LOAIYEUCAU_CREATE_PATH = `${LOAIYEUCAU_PATH}/them`;
const LOAIYEUCAU_EDIT_PATH = `${LOAIYEUCAU_PATH}/sua`;

const NHIEMVUKHAC_PATH = '/nhiem-vu-khac';
const NHIEMVUKHAC_CREATE_PATH = `${NHIEMVUKHAC_PATH}/them`;
const NHIEMVUKHAC_EDIT_PATH = `${NHIEMVUKHAC_PATH}/sua`;
const NHIEMVUKHAC_CONGVIEC_PATH = `${NHIEMVUKHAC_PATH}/cong-viec`;

const NHIEMVU_CANHAN_PATH = '/nhiem-vu-ca-nhan';

const NGUOIPHOIHOP_PATH = '/nguoi-phoi-hop';
const NGUOIPHOIHOP_CREATE_PATH = `${NGUOIPHOIHOP_PATH}/them`;
const NGUOIPHOIHOP_EDIT_PATH = `${NGUOIPHOIHOP_PATH}/sua`;

const BAOCAO_THONGKE_PATH = '/bao-cao-thong-ke';
const BAOCAO_TONG_QUAN_NHAN_VIEN_PATH = `${BAOCAO_THONGKE_PATH}/tong-quan-nhan-vien`;
const BAOCAO_CHI_TIET_NHAN_VIEN_PATH = `${BAOCAO_THONGKE_PATH}/chi-tiet-nhan-vien`;
const BAOCAO_CHI_TIET_PHAT_TRIEN_PHAN_MEM_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-phat-trien-phan-mem`;
const BAOCAO_CHI_TIET_XU_LY_YEU_CAU_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-xu-ly-yeu-cau`;
const BAOCAO_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-xu-ly-yeu-cau-thanh-vien`;
const BAOCAO_CHI_TIET_HO_TRO_THANH_VIEN_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-ho-tro-thanh-vien`;
const BAOCAO_CHI_TIET_NHIEM_VU_KHAC_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-nhiem-vu-khac`;
const BAOCAO_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN_PATH =
  `${BAOCAO_THONGKE_PATH}/chi-tiet-nhiem-vu-khac-thanh-vien`;

const BAOCAO_THONG_HOP_NHAN_VIEN_PATH = `${BAOCAO_THONGKE_PATH}/tong-hop-nhan-vien`;

const HOME_PATH = '/trang-chu';

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    LOGIN_SSO_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    APIROLEMAPPING_PATH,
    APIROLEMAPPING_CREATE_PATH,
    APIROLEMAPPING_EDIT_PATH,

    OPENIDDICTAPPLICATION_PATH,
    OPENIDDICTAPPLICATION_CREATE_PATH,
    OPENIDDICTAPPLICATION_EDIT_PATH,

    MENUITEM_PATH,
    MENUITEM_CREATE_PATH,
    MENUITEM_EDIT_PATH,

    ROLE_ACCOUNT_PATH,
    ROLE_ACCOUNT_CREATE_PATH,
    ROLE_ACCOUNT_EDIT_PATH,

    HOTRO_PATH,
    HOTRO_CREATE_PATH,
    HOTRO_EDIT_PATH,

    YEUCAU_PATH,
    YEUCAU_CREATE_PATH,
    YEUCAU_EDIT_PATH,

    KHOA_PATH,
    KHOA_CREATE_PATH,
    KHOA_EDIT_PATH,

    LINHVUC_PATH,
    LINHVUC_CREATE_PATH,
    LINHVUC_EDIT_PATH,

    LOAIYEUCAU_PATH,
    LOAIYEUCAU_CREATE_PATH,
    LOAIYEUCAU_EDIT_PATH,

    BOPHAN_PATH,
    BOPHAN_CREATE_PATH,
    BOPHAN_EDIT_PATH,

    TEAM_PATH,
    TEAM_CREATE_PATH,
    TEAM_EDIT_PATH,

    NHANVIEN_PATH,
    NHANVIEN_CREATE_PATH,
    NHANVIEN_EDIT_PATH,

    QUYTRINH_PATH,
    QUYTRINH_CREATE_PATH,
    QUYTRINH_EDIT_PATH,
    
    PROJECT_PATH,
    PROJECT_CREATE_PATH,
    PROJECT_EDIT_PATH,
    PROJECT_DETAIL_PATH,
    PROJECT_STEP_BOARD_PATH,

    NHIEMVUKHAC_PATH,
    NHIEMVUKHAC_CREATE_PATH,
    NHIEMVUKHAC_EDIT_PATH,
    NHIEMVUKHAC_CONGVIEC_PATH,

    NHIEMVU_CANHAN_PATH,

    NGUOIPHOIHOP_PATH,
    NGUOIPHOIHOP_CREATE_PATH,
    NGUOIPHOIHOP_EDIT_PATH,

    BAOCAO_THONGKE_PATH,
    BAOCAO_TONG_QUAN_NHAN_VIEN_PATH,
    BAOCAO_CHI_TIET_NHAN_VIEN_PATH,
    BAOCAO_CHI_TIET_PHAT_TRIEN_PHAN_MEM_PATH,
    BAOCAO_CHI_TIET_XU_LY_YEU_CAU_PATH,
    BAOCAO_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN_PATH,
    BAOCAO_CHI_TIET_HO_TRO_THANH_VIEN_PATH,
    BAOCAO_CHI_TIET_NHIEM_VU_KHAC_PATH,
    BAOCAO_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN_PATH,

    BAOCAO_THONG_HOP_NHAN_VIEN_PATH,

    HOME_PATH,
};
